/**
 * Typed, validated environment. Parsed once at startup so a misconfigured deployment fails
 * immediately and loudly, rather than as `undefined` inside an MSAL authority URL.
 */
import { z } from 'zod'

const envSchema = z.object({
  VITE_ENTRA_TENANT_ID: z.string().min(1),
  VITE_ENTRA_SPA_CLIENT_ID: z.string().min(1),
  /** e.g. api://<api-client-id>/access_as_user — the API's scope, never the SPA's. */
  VITE_ENTRA_API_SCOPE: z.string().min(1),
  /**
   * Base URL of the tRPC API. When empty the app runs on the typed mock fixtures
   * (see ~/lib/api/mock.ts) so the SPA is developable before the backend exists.
   */
  VITE_API_URL: z.string().default(''),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  throw new Error(
    `Ungueltige Umgebungskonfiguration:\n${z.prettifyError(parsed.error)}\n` +
      'Siehe frontend/.env.example.',
  )
}

export const env = parsed.data

/** True while no backend is configured — the app serves typed fixtures instead. */
export const isMockMode = env.VITE_API_URL === ''
